// import React from "react";
import { Typography, Box, Grid, Stack } from "@mui/material";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import "./mainContent.css";
import VendorCard from "../VendorCard/VendorCard";
import BlankCard from "../BlankCard/BlankCard";
import CustomGaugeChart from "../meter/meter";
import MapChart from "../Mapchart/Mapchart";
import BarGraph from "../Delay_In_Filing_Gstr1/BarGraph";
import GSTR3BFilingStatusSummary from "../Gstr3B_filing_satus/GSTRBFilingStatus";
import GSTR31FilingStatusSummary from "../Gstr31_filing_status/GSTR31FilingStatusSummary";
import VendorscoreGraph from "../vendorscorehistory/vendorhistory";
import CurrentScore from "../Current_Scores/CurrentScoreTable";
import BarGraph1 from "../Delay_In_Gstr3b/BarGraph1";
import GSTTable from "../gst_table/gst_table";
import LineGraph from "../Liabilitiesgraph/liabilitiesgraph";
import React, { useEffect, useState } from "react";
import BarChart1 from "../Delay_In_Gstr3b/BarGraph1";
import BarChart2 from "../Delay_In_Filing_Gstr1/BarGraph";
import ChartExample from "../Liabilitiesgraph/liabilitiesgraph";
import HSNCode from "../HSNCODE/hsncode";
import axios from "axios";
import Select from "react-select";
import VendorCard1 from "../VendorCard/Vendorcard1";
import logo1 from "../../../assets/gstin.png";
import GstModal from "../gst_table/GstModal";
import gstimg from '../../../assets/image 1133.png'
import GSTR1FilingChart from "../GSTR1FilingChart";
import GSTR3BFilingChart from "../GSTR3BFilingChart";
import { useLocation } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import taxicon from '../../../../../../../assets/images/taxicon.png'
import { Modal } from "antd";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import styles
import GSTR1FilingDates from "../Gstr1FilingDates/GSTR1FilingDates";
import GSTR3BFilingDates from "../Gstr3BFilingDates/GSTR3BFilingDates";
import { BeatLoader } from "react-spinners";
import { API_ENDPOINT_ADD_GSTIN, 
  API_ENDPOINT_EXEMPTED_DATA, 
  API_ENDPOINT_GET_GSTIN, 
  API_ENDPOINT_GET_GSTIN_DATA, 
  API_ENDPOINT_GET_GSTINS, 
  API_ENDPOINT_GET_INVOICE_SUMMARY, 
  API_ENDPOINT_TOGGLE_DATA } from "app/scenes/VendorFollowUp/vendorfollowup.constants";

const MainContentVendor = ({ gstin, workspace }) => {
  const [ids, setIds] = useState([]);
  const [gstinCount, setGstinCount] = useState("SELECT PAN");
  const [Address, setAddress] = useState("Not Available");
  const [selectedPan, setSelectedPan] = useState("SELECT PAN");
  const [apiData, setApiData] = useState([]);
  const [selectedGstin, setSelectedGstin] = useState("");
  const [lineGraphData1, setLineGraphData] = useState({ labels: [], data: [] });
  const [rgdt, setRgdt] = useState("SELECT GSTIN");
  const [aggreTurnOver, setAggreTurnOver] = useState("SELECT GSTIN");
  const [legalName, setLegalName] = useState("SELECT GSTIN");
  const [tradeName, setTradeName] = useState("SELECT GSTIN");
  const [sts, setStatus] = useState("SELECT GSTIN");
  const [hsnData, setHsnData] = useState([]);
  const [statusColor, setStatusColor] = useState("#FF3F15");
  const [einvoiceStatus, setEinvoiceStatus] = useState("SELECT GSTIN");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);

  // State to store GSTR1 filing dates
  const [gstr1FilingDates, setGstr1FilingDates] = useState([]);

  // State to store GSTR3B filing dates
  const [gstr3bFilingDates, setGstr3bFilingDates] = useState([]);


  const [prevDtls, setPrevDtls] = useState([]);
  const [gstinData, setGstinData] = useState([]);
  const [gstinData1, setGstinData1] = useState([]);
  const [gstinDetails, setGstinDetails] = useState({});
  const [filingData, setFilingData] = useState({});
  const [Avgdelaydata, setAvgdelaydata] = useState({});

  const [filteredData, setFilteredData] = useState([]);

  const [panData, setPanData] = useState([]);
  // const [PiechartData, setPiechartData] = useState([]);
  const [filteredPanData, setFilteredPanData] = useState([]);
  const [highlightGstin, setHighlightGstin] = useState(null)
  const [loading, setLoading] = useState(false); // Loader state




  console.log("gstin", gstin);




  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Ensure loading starts before try block
      console.log("Loader activated (should be true):", true);

      try {
        // Simulating a network request delay (REMOVE this in production)
        await new Promise((resolve) => setTimeout(resolve, 2000));

        if (gstin) {
          console.log("Selected GSTIN:", gstin);
          handleGstinSelection(gstin);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
        console.log("Loader deactivated (should be false):", false);
      }
    };

    fetchData();
  }, [gstin]);

  const [invoiceSummary, setInvoiceSummary] = useState({
    totalInvoices: 0,
    receivedInvoices: 0,
    notReceivedInvoices: 0,
    receivedPercentage: 0,
    notReceivedPercentage: 0,
    totalGstAmount: 0
  });

  // Function to fetch the invoice summary from the API
  const fetchInvoiceSummary = async () => {
    console.log(workspace,"workspace in fetch invoice summary")
    const currentWorkspace = localStorage.getItem("currentWorkspace");
    try {
      const response = await fetch(API_ENDPOINT_GET_INVOICE_SUMMARY, {
        // const response = await fetch("http://localhost:5000/tvf/get_invoice_summary", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ctin: gstin,         // Pass the gstin as ctin
          workspace_id: currentWorkspace, // Pass workspace as workspace_name
        }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data,"data in main content")
        setInvoiceSummary(data);  // Update state with the API response
      } else {
        console.error('Error fetching invoice summary:', response.statusText);
      }
    } catch (error) {
      console.error('Error calling API:', error);
    }
  };

  // Call the API when the component mounts or gstin/workspace changes
  useEffect(() => {
    fetchInvoiceSummary();
  }, [gstin, workspace]);  // Dependency array ensures the call happens when gstin or workspace changes


  const handleAutoPanSelection = async (selectedOption) => {
    const pan = selectedOption;
    console.log("pan:", pan);

    setSelectedPan(pan);
    try {
      const response = await fetch(
       API_ENDPOINT_GET_GSTIN ,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ pan_number: pan }),
        }
      );
      const data = await response.json();
      // Get the GSTINs
      const gstinIds = data.gstin_ids;
      // Update the GSTIN count
      setGstinCount(gstinIds.length);
      // Store the GSTINs in state
      setFilteredData(gstinIds);
      setGstinData1(gstinIds)


    } catch (error) {
      console.error("Error fetching GSTIN count:", error);
      setGstinCount(0); // Reset count in case of error
    }
  };






  const handleGstinSelection = async (selectedOption) => {
    setLoading(true);
    if (!selectedOption) {
      console.error('Invalid selected option:', selectedOption);
      return; // Exit if the input is not valid
    }

    // Extract the GSTIN ID, handling cases where selectedOption might be a string or an object
    const selectedGstinId = selectedOption.value || selectedOption;

    // Check if selectedGstinId is a string (add more validation if needed)
    if (typeof selectedGstinId !== 'string' || selectedGstinId.trim() === '') {
      console.error('Invalid GSTIN ID:', selectedGstinId);
      return; // Exit if the GSTIN ID is not a valid string
    }

    // Proceed with the function if the selected GSTIN ID is valid
    setSelectedGstin(selectedGstinId);

    // Continue with any additional logic you need
    console.log("Selected GSTIN:", selectedGstinId);

    // Extract PAN from the selected GSTIN (assuming PAN is part of the GSTIN)
    const extractedPan = selectedGstinId.slice(2, -3);
    setSelectedPan(extractedPan); // Set the selected PAN in the PAN dropdown

    const email = localStorage.getItem("email")

    const tokenResponse = await axios.post("https://vendor-score.finkraftai.com/create-token", {
      email: email,
    });

    const token = tokenResponse.data.access_token; // extract token from response

    if (selectedGstinId) {
      try {
        // const token = localStorage.getItem("token");
        // Fetch data from the first API endpoint
        const response1 = await axios.get(
          `${API_ENDPOINT_GET_GSTINS}/${selectedGstinId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data1 = response1.data;

        console.log("data1:", data1);

        // Fetch data from the second API endpoint
        const response2 = await fetch(
          API_ENDPOINT_GET_GSTIN_DATA,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id: selectedGstinId }),
          }
        );

        if (!response2.ok) {
          throw new Error("Failed to fetch GSTIN data from second API");
        }

        const data2 = await response2.json();
        console.log(data2);

        const response3 = await fetch(
          API_ENDPOINT_GET_GSTIN,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ pan_number: extractedPan }),
          }
        );
        const data = await response3.json();
        const gstinIds = data.gstin_ids;
        setGstinCount(gstinIds.length);
        setGstinData1(gstinIds);

        // Combine and process the data
        setGstinDetails({
          total_weightage: data1.total_weightage,
          gstr1_current_weightage: data1.gstr1_current_weightage,
          gstr1_previous_weightage: data1.gstr1_previous_weightage,
          gstr3b_recent_weightage: data1.gstr3b_recent_weightage,
          gstr3b_previous_weightage: data1.gstr3b_previous_weightage,
          liability_payment_score: data1.liability_payment_score,
        });

        setFilingData(data1.filing_data);
        console.log("filing:", data1.filing_data);
        console.log("Avg_data:", data1.Avg_data);

        setAvgdelaydata(data1.Avg_data);

        if (data2.liabilityhistory) {
          const { liabilityhistory } = data2;
          setPrevDtls(liabilityhistory.prevdtls);
        } else {
          setLineGraphData({ labels: [], data: [] }); // Reset data if not found
        }

        const { info } = data2;
        console.log(info,"info in the main content")
        if (info) {
          setRgdt(info.rgdt || "Not Available");
          setAggreTurnOver(info.aggreTurnOver || "Not Available");
          setLegalName(info.lgnm || "Not Available");
          setTradeName(info.tradeNam || "Not Available");
          setStatus(info.sts || "Not Available");
          if (info.einvoiceStatus === "Yes") {
            setEinvoiceStatus("Eligible");
            setStatusColor("#00A859"); // Green color for eligible
          } else if (info.einvoiceStatus === "No") {
            setEinvoiceStatus("Not Eligible");
            setStatusColor("#FF3F15"); // Red color for not eligible
          } else {
            setEinvoiceStatus("Not Available");
            setStatusColor("#B0B0B0"); // Gray color for not available
          }
        } else {
          setEinvoiceStatus("Not Available");
          setStatusColor("#B0B0B0");
          setStatus("Not Available");
        }

        const { enablement } = data2
        if (enablement) {
          console.log("einvoiceStatus", enablement.einvoiceStatus)
          if (enablement.einvoiceStatus === "Yes") {
            setEinvoiceStatus("Eligible");
            setStatusColor("#00A859"); // Green color for eligible
          } else if (enablement.einvoiceStatus === "No") {
            setEinvoiceStatus("Not Eligible");
            setStatusColor("#FF3F15"); // Red color for not eligible
          } else {
            setEinvoiceStatus("Not Available");
            setStatusColor("#B0B0B0"); // Gray color for not available
          }
        } else {
          setEinvoiceStatus("Not Available");
          setStatusColor("#B0B0B0");
        }


        const { enablement_gov } = data2
        if (enablement_gov) {
          console.log("einvoiceStatus", enablement_gov.einvoiceStatus)
          if (enablement_gov.einvStatus === "Y") {
            setEinvoiceStatus("Eligible");
            setStatusColor("#00A859"); // Green color for eligible
          } else if (enablement_gov.einvStatus === "N") {
            setEinvoiceStatus("Not Eligible");
            setStatusColor("#FF3F15"); // Red color for not eligible
          } else {
            setEinvoiceStatus("Not Available");
            setStatusColor("#B0B0B0"); // Gray color for not available
          }
        } else {
          setEinvoiceStatus("Not Available");
          setStatusColor("#B0B0B0");
        }

        const { pob } = data2;
        if (pob) {
          const address = pob?.pradr?.adr || "Not Available";
          setAddress(address);
        }

        const { HSN } = data2;

        console.log("HSN data:", HSN); // Debugging log to see HSN data

        if (HSN && (HSN.bzgddtls || HSN.bzsdtls)) {
          const details = HSN.bzgddtls || HSN.bzsdtls; // Use the available key
          const extractedData = details.map((item) => ({
            gdes: item.gdes || item.sdes,
            hsncd: item.hsncd || item.saccd
          }));
          console.log("hsn data added", extractedData);

          setHsnData(extractedData);

          // Assuming `data2` contains the API response

          const filingHistory = data2.filinghistory
          console.log("Filing history:", filingHistory); // Debugging log to see filing history
                const gstr1FilingDates = [];
        const gstr3bFilingDates = [];

          const yearsToCheck = ["2025", "2024"];

yearsToCheck.forEach((year) => {
  if (filingHistory && filingHistory[year]) {
    const filingStatus = filingHistory[year].filingStatus;

    if (Array.isArray(filingStatus)) {
      filingStatus.forEach((filingArray) => {
        if (Array.isArray(filingArray)) {
          filingArray.forEach((filing) => {
            const { rtntype, dof, taxp } = filing;

            if (rtntype === "GSTR1") {
              gstr1FilingDates.push({ year, month: taxp, dateOfFiling: dof });
            } else if (rtntype === "GSTR3B") {
              gstr3bFilingDates.push({ year, month: taxp, dateOfFiling: dof });
            }
          });
        }
      });
    }
  }
});

console.log("GSTR1 Filing Dates:", gstr1FilingDates);

setGstr1FilingDates(gstr1FilingDates);
  setGstr3bFilingDates(gstr3bFilingDates);
        } else {
          console.log("No hsn data");
        }


      } 
      catch (error) {
        console.error("Error fetching GSTIN data:", error);
        setGstinDetails({});
        setFilingData({});
        setLineGraphData({ labels: [], data: [] });
        setRgdt("Not Available");
        setAggreTurnOver("Not Available");
        setEinvoiceStatus("Not Available");
        setStatusColor("#B0B0B0");
        setAddress("Not Available");
        // Handle 404 (Not Found) separately
        if (error.response && error.response.status === 404) {
          console.warn("GSTIN not found, attempting to add it...");

          try {
            // Call the API to add the GSTIN
            const addResponse = await axios.post(
              API_ENDPOINT_ADD_GSTIN,
              { gstin: selectedGstinId }
            );

            if (addResponse.status === 200 || addResponse.status === 201) {
              console.log("GSTIN added successfully. Retrying selection...");

              // Call handleGstinSelection again with the same GSTIN after successful addition
              await handleGstinSelection(selectedOption);
            } else {
              console.error("Failed to add GSTIN:", addResponse.data);
            }
          } catch (addError) {
            console.error("Error adding GSTIN:", addError);
          }
        } else {
          console.error("Error fetching GSTIN data:", error);
        }
      }
      finally {
        setLoading(false); // Stop loader when API call finishes
      }
    } else {
      setGstinDetails({});
      setFilingData({});
      setLineGraphData({ labels: [], data: [] });
      setRgdt("Not Available");
      setAggreTurnOver("Not Available");
      setEinvoiceStatus("Not Available");
      setStatusColor("#B0B0B0");
      setAddress("Not Available");
    }
  };


  const options = filteredData.map((gstin) => ({
    value: gstin,
    label: gstin,
  }));

  // Handle input change to filter data based on user input
  const handleInputChange = (inputValue) => {
    if (inputValue) {
      const filtered = gstinData.filter((gstin) =>
        gstin.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      // Show only the first 100 items if no input is provided
      setFilteredData(gstinData.slice(0, 5000));
    }
  };

  const handlePanInputChange = (inputValue) => {
    if (inputValue) {
      const filtered = panData.filter((pan) =>
        pan.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredPanData(filtered);
    } else {
      // Show only the first 100 items if no input is provided
      setFilteredPanData(panData.slice(0, 5000));
    }
  };

  const options1 = filteredPanData.map((pan) => ({
    value: pan,
    label: pan,
  }));

  const panoptions = panData.map((pan) => ({
    value: pan,
    label: pan,
  }));

  const handlePanSelection = async (selectedOption) => {
    const pan = selectedOption.value;
    console.log("pan:", pan);

    setSelectedPan(pan);
    try {
      const response = await fetch(
        API_ENDPOINT_GET_GSTIN,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ pan_number: pan }),
        }
      );
      const data = await response.json();
      // Get the GSTINs
      const gstinIds = data.gstin_ids;
      // Update the GSTIN count
      setGstinCount(gstinIds.length);
      // Store the GSTINs in state
      setFilteredData(gstinIds);
      setGstinData1(gstinIds)

      if (gstinIds.length > 0) {
        handleGstinSelection(gstinIds[0]);
      }
    } catch (error) {
      console.error("Error fetching GSTIN count:", error);
      setGstinCount(0); // Reset count in case of error
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#ebf5f6',  // Light teal color like the background
      borderColor: '#d6e8e8',  // Border color similar to the image
      borderRadius: '20px',  // Rounded edges
      minHeight: '30px',
      boxShadow: state.isFocused ? '0 0 0 2px #77c9c9' : null,  // Add border shadow on focus
      '&:hover': {
        borderColor: '#77c9c9',  // Change border color on hover
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 10px',  // Adjust padding for text alignment
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#007c7c',  // Teal placeholder color
      fontSize: '16px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#0A8394',  // Teal text for the selected value
      fontSize: '16px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#0A8394',  // Teal color for dropdown arrow
    }),
    indicatorSeparator: () => ({
      display: 'none',  // Remove separator between input and dropdown arrow
    }),
  };

  const onBtnClicked = () => {
    if (selectedGstin) {
      setIsModalVisible(true);
    }
    else {
      alert('Please select GSTIN')
    }
  };

  const handleGstinSelect = (gstin) => {
    console.log('Selected GSTIN:', gstin);
    setHighlightGstin(gstin);
    // You can now use the selected GSTIN as needed
  };

  const [isToggled, setIsToggled] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);


  // const handleToggle = async () => {
  //   if (isDisabled) return; // Prevent toggling if disabled

  //   const newToggleState = !isToggled; // Determine new state
  //   setIsToggled(newToggleState);

  //   if (newToggleState) {
  //     // Call POST API when the toggle is switched ON
  //     await handleApiCall("POST");
  //   } else {
  //     // Call DELETE API when the toggle is switched OFF
  //     await handleApiCall("DELETE");
  //   }
  // };

  useEffect(() => {
    const getVendorDetails = async () => {
      const vendorDetails = await fetchVendorDetails(gstin);
      const isExempted = vendorDetails?.vendor_data?.exemptionStatus === "true";

      if (isExempted) {
        setIsToggled(true); // Force toggle to ON if exemptionStatus is true
      }
    };

    getVendorDetails(); // Call the function inside useEffect
  }, [gstin]); // Empty dependency array ensures it runs only once

  const handleToggle = async () => {
    const newToggleState = !isToggled;

    setIsToggled(newToggleState);

    if (newToggleState) {
      await handleApiCall("POST");
    } else {
      await handleApiCall("DELETE");
    }
  };

  const fetchVendorDetails = async (gstin) => {
    console.log("Inside fetchVendorDetails");
    try {
      const response = await fetch(API_ENDPOINT_TOGGLE_DATA, {
        method: "POST", // Changed to POST
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ gstin, collectionName: "vendor_tally" }), // Sending data in request body
      });
      const data = await response.json();
 
      if (data.exemptionStatus===true || data.einvoiceEligibility===true) {
        setIsToggled(true);
      } else {
        setIsToggled(false);
      }
  
      return await response.json();
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  
  

  // handleApiCall to call the respective APIs
  const handleApiCall = async (method) => {
    const currentWorkspace = localStorage.getItem('currentWorkspace');
    try {
      const response = await fetch(API_ENDPOINT_EXEMPTED_DATA + (method === "POST" ? "/add-exempted-data" : "/delete-exempted-vendor"), {
        // const response = await fetch("http://localhost:5000" + (method === "POST" ? "/add-exempted-data" : "/delete-exempted-vendor"), {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          gstin: gstin, // Pass the GSTIN
          legalName: legalName, // Pass the legal name
          workspaceid: currentWorkspace
        }),
      });

      const data = await response.json();
      if (response.ok) {
        if (method === "POST") {
          // Show success notification
          toast.success("Status Updated to Exempted");
        } else {
          // Show success notification for deletion
          toast.success(`Vendor Removed From Exempted`);
        }
      } else {
        toast.error(`Failed to complete action: ${data.message || "Unknown error"}`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  // useEffect(() => {
  //   const fetchExemptedData = async () => {
  //     try {
  //       const response = await axios.get("https://fuzzyapi.finkraftai.com/get-gst-exempted-data");
  //       const exemptedData = response.data;

  //       // Find the entry matching the provided GSTIN
  //       const gstinData = exemptedData.find(item => item.gstin === gstin);

  //       if (gstinData) {
  //         // If the GSTIN is found
  //         if (gstinData.source === "govportal") {
  //           setIsDisabled(true); // Disable the toggle if the source is 'govportal'
  //           setIsToggled(false); // Ensure the toggle is off
  //         } else if (gstinData.source === "manual") {
  //           setIsDisabled(false); // Enable the toggle if the source is 'manual'
  //           setIsToggled(true); // Ensure the toggle is on
  //         }
  //       } else {
  //         setIsDisabled(false); // Enable the toggle
  //         setIsToggled(false); // Ensure the toggle is off
  //       }
  //     } catch (error) {
  //       console.error("Error fetching exempted GST data:", error);
  //     }
  //   };

  //   fetchExemptedData();
  // }, [gstin]); // Re-run effect when `gstin` changes


  // Modal state
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");





  return (
    <div className="mainsection-vendor">
      <ToastContainer position="top-center" autoClose={5000} hideProgressBar={true} />

      <div className="vendor-navbar">
        {loading && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10,
            padding: ' 500px 400px'
          }}>
            <BeatLoader color="#36D7B7" size={20} />
          </div>
        )}
        <div>
          <p> Vendor Status : <span className="mainheader">{sts}</span></p>
          <p>Gstin : <span className="mainheader">{gstin}</span></p>
          <p> Legal Name : <span className="mainheader">{legalName}</span></p>
          <p> Trade Name : <span className="mainheader">{tradeName} </span></p>
          <p>Address : {Address}</p>
        </div>


      </div>
      <div className="Topdiv">
        <div className="cards-row">
          <div className="smallcard1">
            <div className="img-div">
              <img src={logo1} className="vendor-img" />
            </div>
            <p className="c-des">No. of GSTINs</p>
            <h4 className="c-head">{gstinCount}</h4>
          </div>
          <div className="smallcard1">
            <div className="img-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                className="vendor-img"
              >
                <path
                  d="M13 5.66667V3.66667C13 2.93029 12.3284 2.33333 11.5 2.33333H2.5C1.67157 2.33333 1 2.93029 1 3.66667V5.66667M13 5.66667V11.6667C13 12.4031 12.3284 13 11.5 13H2.5C1.67157 13 1 12.4031 1 11.6667V5.66667M13 5.66667H1M4 1V3.66667M10 1V3.66667"
                  stroke="#0A8394"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
            </div>

            <p className="c-des">Date of Registration</p>
            <h4 className="c-head">{rgdt}</h4>
          </div>
          <div className="smallcard1">
            <div className="img-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className="vendor-img"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.5 1.56C8.66575 1.56 8.82475 1.62585 8.94194 1.74305L13.3169 6.11806C13.561 6.36212 13.561 6.75787 13.3169 7.00194C13.0729 7.246 12.6771 7.246 12.4331 7.00194L9.125 3.69388V12.185C9.125 12.5302 8.84519 12.81 8.5 12.81C8.15481 12.81 7.875 12.5302 7.875 12.185V3.69388L4.56694 7.00194C4.32286 7.246 3.92714 7.246 3.68306 7.00194C3.43898 6.75787 3.43898 6.36212 3.68306 6.11806L8.05806 1.74305C8.17525 1.62585 8.33425 1.56 8.5 1.56Z"
                  fill="#0A8394"
                />
              </svg>
            </div>
            <p className="c-des">E Annual Aggregate Turnover</p>
            <h4 className="c-head">{aggreTurnOver}</h4>
          </div>
          <div className="smallcard1">
            <div className="img-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className="vendor-img"
              >
                <g clip-path="url(#clip0_1099_4749)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.59551 1.06345C4.94338 0.889529 5.3584 0.684998 6.125 0.684998C6.89156 0.684998 7.30662 0.88951 7.6545 1.06344L7.66444 1.06842C7.93669 1.20457 8.14744 1.30994 8.625 1.30995C9.39819 1.30999 9.85612 1.02169 10.0088 0.906948C10.2465 0.728323 10.5273 0.743385 10.7212 0.83306C10.9176 0.923891 11.125 1.14062 11.125 1.46092V8.185H13C14.0351 8.185 14.875 9.02343 14.875 10.0594V11.935C14.875 12.5131 14.7287 12.9882 14.4771 13.3657C14.2281 13.7392 13.9005 13.9804 13.592 14.1346C13.2859 14.2877 12.9874 14.3611 12.7707 14.3972C12.6406 14.4189 12.5072 14.4352 12.375 14.435h4.625C3.04689 14.435 2.57175 14.2887 2.19433 14.0371C1.82082 13.7881 1.57962 13.4605 1.42536 13.152C1.27232 12.8459 1.19892 12.5474 1.1628 12.3307C1.14449 12.2209 1.1351 12.128 1.13025 12.0601C1.12621 12.0036 1.12502 11.9701 1.125 11.935V1.46091C1.125 1.14062 1.3324 0.923891 1.52879 0.83306C1.72267 0.743379 2.00351 0.728316 2.24118 0.906929C2.39387 1.02167 2.85181 1.30995 3.625 1.30995C4.10259 1.30995 4.3133 1.20459 4.58555 1.06844L4.59551 1.06345ZM2.37707 11.935L2.375 2.36232C2.71261 2.4761 3.12958 2.55995 3.625 2.55995C4.3916 2.55995 4.80662 2.35543 5.15449 2.1815L5.16445 2.17652C5.4367 2.04037 5.64741 1.935 6.125 1.935C6.60261 1.935 6.81331 2.04037 7.08556 2.17652L7.0955 2.18149C7.44338 2.35541 7.85838 2.55993 8.625 2.55995C9.12044 2.55997 9.53738 2.47613 9.875 2.36233V11.935C9.875 12.4244 9.97987 12.84 10.1647 13.185h4.625C3.26561 13.185 3.03762 13.0969 2.88771 12.997C2.73387 12.8944 2.62351 12.7532 2.54339 12.593C2.46205 12.4303 2.41827 12.2601 2.39579 12.1252C2.38523 12.0618 2.37882 11.999 2.37707 11.935ZM12.5652 13.1642C12.7001 13.1417 12.8703 13.0979 13.033 13.0166C13.1932 12.9365 13.3344 12.8261 13.437 12.6723C13.5369 12.5224 13.625 12.2944 13.625 11.935V10.0594C13.625 9.71462 13.3456 9.435 13 9.435H11.125V11.935C11.125 12.2944 11.2131 12.5224 11.313 12.6723C11.4156 12.8261 11.5568 12.9365 11.717 13.0166C11.8797 13.0979 12.0499 13.1417 12.1848 13.1642C12.2507 13.1752 12.3043 13.1804 12.3389 13.1829C12.4143 13.1883 12.4911 13.1766 12.5652 13.1642Z"
                    fill="#0A8394"
                  />
                  <path
                    d="M3.625 5.06C3.625 4.71482 3.90483 4.435 4.25 4.435H8C8.34519 4.435 8.625 4.71482 8.625 5.06C8.625 5.40518 8.34519 5.685 8 5.685H4.25C3.90483 5.685 3.625 5.40518 3.625 5.06Z"
                    fill="#0A8394"
                  />
                  <path
                    d="M3.625 7.56C3.625 7.21481 3.90483 6.935 4.25 6.935H8C8.34519 6.935 8.625 7.21481 8.625 7.56C8.625 7.90519 8.34519 8.185 8 8.185H4.25C3.90483 8.185 3.625 7.90519 3.625 7.56Z"
                    fill="#0A8394"
                  />
                  <path
                    d="M3.625 10.06C3.625 9.71481 3.90483 9.435 4.25 9.435H8C8.34519 9.435 8.625 9.71481 8.625 10.06C8.625 10.4052 8.34519 10.685 8 10.685H4.25C3.90483 10.685 3.625 10.4052 3.625 10.06Z"
                    fill="#0A8394"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1099_4749">
                    <rect
                      width="15"
                      height="15"
                      fill="white"
                      transform="translate(0.5 0.0599976)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p className="c-des">E-Invoicing</p>
            <h4 className="c-head" style={{ color: statusColor }}>{einvoiceStatus}</h4>
          </div>

          <div className="smallcard1">
            <div style={{ display: 'flex', gap: '10px', marginBottom: '5%', alignItems: 'center' }}>
              <div style={{ background: '#0A8394', borderRadius: '4px', color: 'white', padding: '3px 10px', border: 'none' }}>
                T
              </div>
              <h4 style={{ fontWeight: '500', fontSize: '15px', color: '#72747D' }}>Total no. of E-invoice Not filed</h4>
              <div style={{ marginLeft: 'auto' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" >
                  <path d="M9.16663 9.99992C9.16663 10.2209 9.25442 10.4329 9.4107 10.5892C9.56698 10.7455 9.77895 10.8333 9.99996 10.8333C10.221 10.8333 10.4329 10.7455 10.5892 10.5892C10.7455 10.4329 10.8333 10.2209 10.8333 9.99992C10.8333 9.7789 10.7455 9.56694 10.5892 9.41066C10.4329 9.25438 10.221 9.16659 9.99996 9.16659C9.77895 9.16659 9.56698 9.25438 9.4107 9.41066C9.25442 9.56694 9.16663 9.7789 9.16663 9.99992Z" stroke="#0A8394" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9.16663 15.8333C9.16663 16.0543 9.25442 16.2662 9.4107 16.4225C9.56698 16.5788 9.77895 16.6666 9.99996 16.6666C10.221 16.6666 10.4329 16.5788 10.5892 16.4225C10.7455 16.2662 10.8333 16.0543 10.8333 15.8333C10.8333 15.6122 10.7455 15.4003 10.5892 15.244C10.4329 15.0877 10.221 14.9999 9.99996 14.9999C9.77895 14.9999 9.56698 15.0877 9.4107 15.244C9.25442 15.4003 9.16663 15.6122 9.16663 15.8333Z" stroke="#0A8394" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9.16663 4.16659C9.16663 4.3876 9.25442 4.59956 9.4107 4.75584C9.56698 4.91212 9.77895 4.99992 9.99996 4.99992C10.221 4.99992 10.4329 4.91212 10.5892 4.75584C10.7455 4.59956 10.8333 4.3876 10.8333 4.16659C10.8333 3.94557 10.7455 3.73361 10.5892 3.57733C10.4329 3.42105 10.221 3.33325 9.99996 3.33325C9.77895 3.33325 9.56698 3.42105 9.4107 3.57733C9.25442 3.73361 9.16663 3.94557 9.16663 4.16659Z" stroke="#0A8394" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            <h1 style={{ color: '#0A8394' }}>{invoiceSummary.notReceivedInvoices}/{invoiceSummary.totalInvoices}{"  "}({parseFloat(invoiceSummary.notReceivedPercentage).toFixed(0)}%
              )</h1>
          </div>
          <div className="smallcard1">
            <div style={{ display: 'flex', gap: '10px', marginBottom: '5%', alignItems: 'center' }}>
              <div style={{ background: '#FF3E34', borderRadius: '4px', color: 'white', padding: '3px 10px', border: 'none' }}>
                A
              </div>
              <h4 style={{ fontWeight: '500', fontSize: '15px', color: '#72747D' }}>Total Gst taxable amount at risk</h4>
              <div style={{ marginLeft: 'auto' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginLeft: 'auto' }}>
                  <path d="M9.16663 9.99992C9.16663 10.2209 9.25442 10.4329 9.4107 10.5892C9.56698 10.7455 9.77895 10.8333 9.99996 10.8333C10.221 10.8333 10.4329 10.7455 10.5892 10.5892C10.7455 10.4329 10.8333 10.2209 10.8333 9.99992C10.8333 9.7789 10.7455 9.56694 10.5892 9.41066C10.4329 9.25438 10.221 9.16659 9.99996 9.16659C9.77895 9.16659 9.56698 9.25438 9.4107 9.41066C9.25442 9.56694 9.16663 9.7789 9.16663 9.99992Z" stroke="#0A8394" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9.16663 15.8333C9.16663 16.0543 9.25442 16.2662 9.4107 16.4225C9.56698 16.5788 9.77895 16.6666 9.99996 16.6666C10.221 16.6666 10.4329 16.5788 10.5892 16.4225C10.7455 16.2662 10.8333 16.0543 10.8333 15.8333C10.8333 15.6122 10.7455 15.4003 10.5892 15.244C10.4329 15.0877 10.221 14.9999 9.99996 14.9999C9.77895 14.9999 9.56698 15.0877 9.4107 15.244C9.25442 15.4003 9.16663 15.6122 9.16663 15.8333Z" stroke="#0A8394" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9.16663 4.16659C9.16663 4.3876 9.25442 4.59956 9.4107 4.75584C9.56698 4.91212 9.77895 4.99992 9.99996 4.99992C10.221 4.99992 10.4329 4.91212 10.5892 4.75584C10.7455 4.59956 10.8333 4.3876 10.8333 4.16659C10.8333 3.94557 10.7455 3.73361 10.5892 3.57733C10.4329 3.42105 10.221 3.33325 9.99996 3.33325C9.77895 3.33325 9.56698 3.42105 9.4107 3.57733C9.25442 3.73361 9.16663 3.94557 9.16663 4.16659Z" stroke="#0A8394" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            {/* <h1 style={{color:'#FF3E34'}}>INR {invoiceSummary.totalGstAmount}</h1> */}
            <h1 style={{ color: '#FF3E34' }}>
              INR {new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(Math.round(invoiceSummary.totalGstAmount))}
            </h1>

          </div>

          <div className="smallcard3">
            <div className="img-div">
              <img src={taxicon} className="vendor-img" />
            </div>
            <div>
              <h1 style={{ fontWeight: 600 }}>Exempted vendor</h1>
              <p>exempt from the e-invoice mandate and need not generate an e-invoice under GST.</p>
            </div>
            <div className="toogle">
              <label className="switch">
                <input type="checkbox" checked={isToggled} disabled={isDisabled} onChange={handleToggle} />
                <span className="slider round"></span>
              </label>
            </div>
          </div>


        </div>

      </div>
      <div2 className="div2">
        {/* <div className="map-chart">
          
          <GSTTable gstinData={gstinData1} onGstinSelect={handleGstinSelect} />
        </div> */}
        <div className="rightContainer">
          <BlankCard
            component={CustomGaugeChart}
            totalWeightage={gstinDetails.total_weightage}
            legalName={legalName}
          />
        </div>

      </div2>
      <div className="div3">

        <div className="right-gstr1">
          <GSTR31FilingStatusSummary Avgdelaydata={Avgdelaydata} gstr1FilingDates={gstr1FilingDates} />
          {/* <GSTR1FilingDates gstr1FilingDates={gstr1FilingDates} /> */}
        </div>
      </div>
      <div className="div4">

        <div className="right-gstr3b">
          <GSTR3BFilingStatusSummary Avgdelaydata={Avgdelaydata} gstr3bFilingDates={gstr3bFilingDates} />
          {/* <GSTR3BFilingDates gstr3bFilingDates={gstr3bFilingDates} /> */}
        </div>
      </div>
      <div className="div5">
        <div className="hsndiv">
          <HSNCode hsnData={hsnData} />
        </div>

      </div>
    </div>
  );
};

export default MainContentVendor;
